module.exports = __webpack_public_path__ + "img/yurtlarburada-default.118e54a2.jpg";